import { render, staticRenderFns } from "./CardBarChart.vue?vue&type=template&id=5d115d7a&scoped=true"
import script from "./CardBarChart.vue?vue&type=script&lang=js"
export * from "./CardBarChart.vue?vue&type=script&lang=js"
import style0 from "./CardBarChart.vue?vue&type=style&index=0&id=5d115d7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d115d7a",
  null
  
)

export default component.exports